import { render, staticRenderFns } from "./RemindDetail.vue?vue&type=template&id=c7da3d28&scoped=true"
import script from "./RemindDetail.vue?vue&type=script&lang=js"
export * from "./RemindDetail.vue?vue&type=script&lang=js"
import style0 from "./RemindDetail.vue?vue&type=style&index=0&id=c7da3d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7da3d28",
  null
  
)

export default component.exports